/**
 * Single source of truth for odds validity and market suspension (Horses, Tennis, Football, and shared with cricket helpers).
 * Used by: lobby match cards, Trader market-display, and trade slip so they always show the same thing.
 *
 * - Dead / suspended display: finite and <= 1 (exact 1.00 or below). Values > 1 are valid even if they round to "1.00" at 2dp (e.g. 1.001).
 * - Display: use formatOddsForDisplay so 1.001-style prices are not shown as "1.00".
 * - Market suspended: market.suspended === true (e.g. back-overround from API).
 */

/** True when odds should be treated as dead / SUS (not offerable). Only <= 1, not float "almost 1.00" above 1. */
export function isOddsEffectivelyOne(n) {
  return Number.isFinite(n) && n <= 1;
}

/**
 * Format decimal odds for UI. Usually 2dp; if value is > 1 but rounds to "1.00" at 2dp, show enough decimals (e.g. 1.001).
 */
export function formatOddsForDisplay(odds) {
  const n = odds != null ? Number(odds) : NaN;
  if (!Number.isFinite(n)) return "";
  if (n > 1 && n.toFixed(2) === "1.00") {
    return String(parseFloat(n.toFixed(12)));
  }
  return n.toFixed(2);
}

export function hasValidOdds(odds) {
  const n = odds != null ? Number(odds) : NaN;
  return Number.isFinite(n) && n > 0 && !isOddsEffectivelyOne(n);
}

export function isMarketSuspended(market) {
  return market?.suspended === true;
}

/** Use for any odds cell that shows "SUS" so styling stays consistent (grey, not blue/pink). */
export const suspendedOddsCellClassName =
  "bg-marketGrey text-marketGreyText cursor-not-allowed";
